/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';

export const Container = styled.hr`
  width: 100%;

  ${({ width }) => width && css`
    width: ${width};
  `}

  @media screen and (max-width: 768px) { 
    width: 80%;

    ${({ width }) => width && css`
      width: ${width};
    `}
  }
`;